import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  updateProfile as firebaseUpdateProfile,
  updateEmail as firebaseUpdateEmail,
  updatePassword as firebaseUpdatePassword,
  sendPasswordResetEmail
} from 'firebase/auth';
import { auth } from '../../../firebaseConfig';
import { updateUserData as updateUserProfileData } from '../../../pages/auth/utils/firebase/userOperations';
import { showErrorToast, showSuccessToast, showInfoToast } from '../../../utils/toastUtils';
import { getErrorMessage } from './utils.js';

// Update user profile
export const updateUserProfile = createAsyncThunk(
  'auth/updateProfile',
  async ({ userId, userData }, { rejectWithValue }) => {
    try {
      // Show loading state
      const toastId = showInfoToast('Updating profile...');

      // Update auth profile if display name or photoURL changed
      if (userData.displayName || userData.photoURL) {
        await firebaseUpdateProfile(auth.currentUser, {
          displayName: userData.displayName,
          photoURL: userData.photoURL
        });
      }

      // Update email if changed
      if (userData.email && userData.email !== auth.currentUser.email) {
        await firebaseUpdateEmail(auth.currentUser, userData.email);
      }

      // Update password if provided
      if (userData.newPassword) {
        await firebaseUpdatePassword(auth.currentUser, userData.newPassword);
      }

      // Update user data in Firestore
      const updatedUser = await updateUserProfileData(userId, userData);

      // Show success message
      showSuccessToast('Profile updated successfully!', { id: toastId });

      return updatedUser;

    } catch (error) {
      console.error('Update profile error:', error);
      const errorMessage = getErrorMessage(error);
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// Send password reset email
export const sendPasswordReset = createAsyncThunk(
  'auth/passwordReset',
  async (email, { rejectWithValue }) => {
    try {
      showInfoToast('Sending password reset email...');
      await sendPasswordResetEmail(auth, email);
      showSuccessToast('Password reset email sent successfully!');
      return true;
    } catch (error) {
      console.error('Password reset error:', error);
      const errorMessage = getErrorMessage(error);
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
